<template>
	<div class="childDiv1" id="page3" ref="mainEl" page="3">
		<div class="childWrapper">
			<div class="relative h-full" ref="wrapEl">
				<p class="absolute top-[60px] left-[30px] z-[9999] text-[30px]">{{ test }}</p>
				<!-- <img alt="" src="images/test.png" class="absolute top-0 left-0 opacity-[0.3] w-full" /> -->
				<img alt="" src="images/1x_images/section1/page3/page3-text.png" srcset="images/2x_images/section1/page3/page3-text.png 2x" class="absolute center top-[140px] z-[40] pointer-events-none" />
				<img alt="" src="images/1x_images/section1/page3/ball-gold.png" srcset="images/2x_images/section1/page3/ball-gold.png 2x" class="absolute top-[144px] left-[-292px] z-[9]" ref="ballGoldRef" />
				<img alt="" src="images/1x_images/section1/page3/ball-black.png" srcset="images/2x_images/section1/page3/ball-black.png 2x" class="absolute top-[896px] left-[800px] z-[8]" ref="ballBlackRef" />
				<img alt="" src="images/1x_images/section1/page3/text-goodstimuli.png" srcset="images/2x_images/section1/page3/text-goodstimuli.png 2x" class="absolute top-[480px] left-[70px] z-[10]" />
				<img alt="" src="images/1x_images/section1/page3/text-badstimuli.png" srcset="images/2x_images/section1/page3/text-badstimuli.png 2x" class="absolute top-[1030px] left-[865px] z-[10]" />
				<img alt="" src="images/1x_images/section1/page3/btn-deepdive.png" srcset="images/2x_images/section1/page3/btn-deepdive.png 2x" class="button absolute center top-[1148px] z-[50]" @click="popup()" ref="btnBtmEl" />

				<p class="absolute bg-[red] w-[20px] aspect-square rounded-full z-[999]" v-for="x in markers" :key="x" :style="{ left: x.left + 'px', top: x.top + 'px', transform: `translate(${x.moveX}px, ${x.moveY}px)` }"></p>

				<!-- actual cells -->
				<Cell :pWidth="500" class="absolute z-[10] top-[545px] left-[270px]" ref="mainCellEl" />

				<!-- fake cells -->
				<Cell2 :pWidth="300" class="absolute z-[5] top-[410px] left-[585px] rotate-[30deg]" ref="smallCellEl_1" />
				<Cell2 :pWidth="300" class="absolute z-[5] top-[770px] left-[100px] rotate-[60deg]" ref="smallCellEl_2" />
				<Cell2 :pWidth="470" class="absolute z-[5] top-[750px] left-[500px] rotate-[100deg]" ref="smallCellEl_3" />

				<!-- transparent cells -->
				<div v-for="x in cells" class="absolute aspect-square bg-[antiquewhite] rounded-full z-[20] opacity-0" :key="x" ref="cellsEl" :style="{ width: `${x.width}px`, top: `${x.top}px`, left: `${x.left}px` }"></div>

				<!-- particles -->
				<Particles :configs="{ type: 'normal', black: 0.35, gold: 0.65, cellPos: cells, stickToCell: [0], stickRate: 0.6, interval: { min: 800, max: 1000 }, size: { min: 22, max: 36 }, goldAbsorbRate: 1, blackAbsorbRate: 0 }" ref="particlesEl" />
			</div>
		</div>

		<!-- modal -->
		<div class="modal" ref="modalEl">
			<div class="childWrapper flex justify-center">
				<img alt="" class="button absolute top-[230px] pointer-events-auto" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="popupClose()" />
				<div class="relative pointer-events-auto h-fit top-[330px]">
					<img alt="" class="" src="images/1x_images/section1/page3/page3-modal.png" srcset="images/2x_images/section1/page3/page3-modal.png 2x" />
					<div class="absolute top-[37px] w-[886.5px] h-[602px] center rounded-[20px] overflow-hidden">
						<img alt="" class="absolute top-[40px] left-[35px] z-[9]" src="images/1x_images/section1/page3/text-page3-modal.png" srcset="images/2x_images/section1/page3/text-page3-modal.png 2x" />
						<img alt="" v-for="x in tweenImages" :key="x.id" class="absolute center" :src="x.src" :srcset="`${x.srcset} 2x`" ref="modalImagesEl" />
					</div>
					<div class="absolute top-[600px] w-fit center">
						<img alt="" src="images/1x_images/section1/page3/page3-bar.png" srcset="images/2x_images/section1/page3/page3-bar.png 2x" class="relative z-[5]" />
						<img alt="" src="images/1x_images/section1/page3/page3-bar-balls.png" srcset="images/2x_images/section1/page3/page3-bar-balls.png 2x" class="absolute top-0 z-[7]" />
					</div>
					<div class="absolute top-[600px] w-[847px] h-[96px] center z-[6]">
						<DragBtn class="absolute bottom-[20px] left-0" @trigger="updateImage" ref="dragBtnEl" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import Cell from "../../components/BubbleDraw1.vue";
import Cell2 from "../../components/BubbleDraw2.vue";
import Particles from "../../components/Particles.vue";
import DragBtn from "../../components/DragButton.vue";

export default {
	name: "page-1",
	components: { Cell, Cell2, Particles, DragBtn },
	data() {
		return {
			test: "",
			animate: true, // always true, false only for testing
			cells: [
				{ width: 240, top: 690, left: 410 },
				{ width: 110, top: 890, left: 195 },
				{ width: 129, top: 510, left: 675 },
				{ width: 170, top: 915, left: 680 },
				// { width: 300, top: 500, left: 650 },
			],
			markers: [],
			stopped: true,
			tweenImages: [
				{ id: 1, src: "images/1x_images/section1/page3/cell-interactive-1.png", srcset: "images/2x_images/section1/page3/cell-interactive-1.png" },
				{ id: 2, src: "images/1x_images/section1/page3/cell-interactive-2.png", srcset: "images/2x_images/section1/page3/cell-interactive-2.png" },
				{ id: 3, src: "images/1x_images/section1/page3/cell-interactive-3.png", srcset: "images/2x_images/section1/page3/cell-interactive-3.png" },
			],
			currentImage: 1,
		};
	},
	methods: {
		animateGoldParticle() {
			var moveY = Math.floor(Math.random() * 200 - 100);
			var currentY = gsap.getProperty(this.$refs.ballGoldRef, "y");
			var speed = 20;
			var duration = Math.abs(currentY - moveY) / speed;

			// prettier-ignore
			gsap.to(this.$refs.ballGoldRef, { force3D: true, y: moveY, duration: duration, ease: "sine.inOut", onComplete: () => {
				this.animateGoldParticle();
			}})
		},
		animateBlackParticle() {
			var moveY = Math.floor(Math.random() * 160 - 80);
			var currentY = gsap.getProperty(this.$refs.ballBlackRef, "y");
			var speed = 20;
			var duration = Math.abs(currentY - moveY) / speed;

			// prettier-ignore
			gsap.to(this.$refs.ballBlackRef, { force3D: true, y: moveY, duration: duration, ease: "sine.inOut", onComplete: ()=> {
				this.animateBlackParticle();
			}})
		},
		popup() {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page1-menu", { autoAlpha: 0 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 1 });
		},
		popupClose() {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page1-menu", { autoAlpha: 1 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
		},
		resetModal() {
			for (var i = 0; i < this.tweenImages.length; i++) {
				var alpha = i == 0 ? 1 : 0;
				gsap.set(this.$refs.modalImagesEl[i], { autoAlpha: alpha });
			}
			this.$refs.dragBtnEl.reset();
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
		},
		updateImage(opacity) {
			gsap.to(this.$refs.modalImagesEl[1], { autoAlpha: opacity, ease: "none", duration: 0.5 });
			gsap.to(this.$refs.modalImagesEl[2], { autoAlpha: opacity, ease: "none", duration: 0.5 });
			// console.log("updateimage", opacity);
		},
		stop() {
			console.log("stop page 3");
			this.stopped = true;
			this.$refs.particlesEl.stop();
			this.$refs.mainCellEl.stop();
			if (this.context) this.context.revert();
			this.resetModal();
		},
		start() {
			if (this.stopped) {
				console.log("start page 3");
				this.stopped = false;
				this.resetModal();

				this.$nextTick(() => {
					if (this.animate) {
						this.context.add(() => {
							this.animateBlackParticle();
							this.animateGoldParticle();
						});
						this.$refs.mainCellEl.start();
						this.$refs.particlesEl.start();
					}
				});
			}
		},
	},
	mounted() {
		gsap.set(this.$refs.wrapEl, { top: aspectRatio < 0.74 ? 0 : "40px" });
		// gsap.set(this.$refs.btnBtmEl, { bottom: aspectRatio < 0.74 ? 0 : "40px" });
		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element
	},
};
</script>

<style></style>
